import { defineMessages } from 'react-intl';

export const scope = 'app.containers.InequalityChooser';

export default defineMessages({
  inputLabel: {
    id: `${scope}.inputLabel`,
    defaultMessage: 'Provide a numeric value',
  },
});
